'use strict';

function PerformanceReviewBasisController(performanceReviewService, $log, $location) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.enableReview = enableReview;

  vm.useNewCode = useNewCode; //Follow up
  vm.useNewAssessment = useNewAssessment; //Assessment initial
  vm.isJointReadyToStart = isJointReadyToStart;
  vm.getIcon = getIcon;
  vm.getBtnClass = getBtnClass;

  function $onInit() {
    vm.basis = vm.data || [];
    vm.questionnaireUrl = performanceReviewService.urls.questionnaire.base;
    vm.agreementUrl = performanceReviewService.urls.agreement.questionnaire.base;
    vm.isOpenForEdit = isOpenForEdit;
    vm.getFollowUpUrl = getFollowUpUrl;
    vm.getIntialAssessmentUrl = getIntialAssessmentUrl;
    vm.getFollowUpStateDisplay = getFollowUpStateDisplay;
    vm.getInitialStateDisplay = getInitialStateDisplay;
    useFollowUpTime();
  }

  function isOpenForEdit(basis) {
    return new Date(basis.transpire).getTime() < new Date().getTime();
  }

  function isJointReadyToStart(basis) {
    if (!basis.initial_assessment) {
      return false;
    }

    return basis.initial_assessment.is_ready_to_start;
  }

  function useFollowUpTime() {
    vm.basis.forEach(function (doc) {
      if (doc.follow_up) {
        if (doc.follow_up.appointment_datetime) {
          doc.transpire = doc.follow_up.appointment_datetime;
        }
      }
    });
  }

  function useNewCode(basis) {
    if (!basis.follow_up) {
      return false;
    }
    if (basis.follow_up.state === 'follow_up_ready') {
      if (basis.follow_up.manager_doc_url) {
        // previous completed follow up exists
        return true;
      }
      return false;
    }
    return true;
  }


  function useNewAssessment(basis) {

    if (basis.follow_up) {
      if (basis.follow_up.manager_doc_url) {
        return false;
      }
    }

    if (!basis.initial_assessment) {
      return false;
    }
    return !!basis.initial_assessment.manager_doc_url;
  }

  function getFollowUpUrl(basis) {
    if (!basis.follow_up) {
      return '#';
    }
    return basis.follow_up.manager_doc_url;
  }

  function getIntialAssessmentUrl(basis) {
    if (!basis.initial_assessment) {
      return '#';
    }
    return basis.initial_assessment.manager_doc_url;
  }

  function getBtnClass(basis) {
    if (!basis.follow_up) {
      return 'btn btn-xs btn-new danger';
    }
    if (basis.follow_up.state === 'follow_up_ready') {
      if (basis.follow_up.coworker_doc_url) {
        return 'btn btn-xs btn-new primary';
      }
    }
    return 'btn btn-xs btn-default';
  }

  function getFollowUpStateDisplay(basis) {
    if (!basis.follow_up) {
      return 'Error';
    }
    return basis.follow_up.button_text;
  }

  function getInitialStateDisplay(basis) {
    if (!basis.initial_assessment) {
      return 'Error';
    }
    return basis.initial_assessment.button_text;
  }

  function getIcon(basis) {
    if (!basis.follow_up) {
      return 'fa fa-circle-exclamation';
    }
    if (basis.follow_up.state === 'follow_up_ready') {
      if (basis.follow_up.coworker_doc_url) {
        return 'fa fa-check';
      }
    }
    return 'fa fa-undo';
  }

  function enableReview(basis) {
    performanceReviewService.update.openForReview(this.round, {token: basis.token}).then(function () {
      $location.path(vm.agreementUrl({token: basis.token}));
    });
  }
}

module.exports = PerformanceReviewBasisController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-basis/performance-review-basis.controller.js
 ** module id = 285
 ** module chunks = 0
 **/